import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Grindhouse fucking rawks",
  "description": "",
  "published": "2009-11-08T00:00:00.000Z",
  "redirect_from": ["/blog/grindhouse-fucking-rawks/swizec/817"],
  "categories": "food for thought, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I watched Grindhouse and even though I fell asleep halfway through I still think this is perhaps one of the biggest film masterpieces I have ever seen.`}</p>
    <p>{`And actually I just wanted to post this here image as proof, don't really have much to say, sorry.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2009/11/2007_grindhouse_pt_003.jpg",
        "alt": "2007_grindhouse_pt_003",
        "title": "2007_grindhouse_pt_003"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      